<script>
	import Layout from '../../layouts/default/index.svelte'
	import Logo from '../../components/logo/logo.svelte'
	import DocumentItem from '../../components/document-item/document-item.svelte'
	import InputFile from '../../components/input-file/input-file.svelte'
	import AddInput from '../../components/add-input/add-input.svelte'
	import Button from '../../components/button/button.svelte'
	import RoundInfoIco from '../../components/icons/round-info.svelte'
	import InputDrag from '../../components/input-drag/input.drag.svelte'
	import Reading from '../../components/reading/reading.svelte'
    import Auth from '../../components/auth/auth.svelte'
    import UploadSeparately from '../../components/upload-separately/upload-separately.svelte'
    import UploadEverything from '../../components/upload-everything/upload-everything.svelte'
    import uploadFilesStoreEverything from '../../store/upload/upload-everything'
    import uploadFilesStoreSeparately from '../../store/upload/upload-separately'

    let isReading = false
    let uploadType = 'everything'

    uploadFilesStoreEverything.isReading.subscribe(value => {
        isReading = value
    })
    uploadFilesStoreSeparately.isReading.subscribe(value => {
        isReading = value
    })

</script>

<style lang="scss">
	h1 {
		font-family: 'Roboto', sans-serif;
		font-weight: 100;
		line-height: 52px;
		font-size: 48px;
		margin-top: 111px;
		text-align: center;
		padding: 0 50px;
		margin-bottom: 80px;
		.strong {
			font-weight: 400;
		}
	}
	.content {
		max-width: 650px;
		padding: 0 20px;
		margin: 0 auto;
		.tabs {
		    border-bottom: 2px solid #2b312e;
		    margin-bottom: 40px;
		    .tab {
		        font-size: 13px;
                font-weight: bold;
                letter-spacing: 0.2px;
                color: #ffffff;
                display: inline-block;
                padding: 10px 20px;
                margin-bottom: -2px;
                text-transform: uppercase;
                cursor: pointer;
                &.active {
                    border-bottom: 3px solid #df4937;
                    cursor: default;
                }
		    }
		}
	}
	.info {
	    padding: 60px 20px 20px;
        text-align: center;
        font-size: 17px;
        font-weight: 300;
        line-height: 1.71;
        letter-spacing: 0.2px;
        color: #808683;
    }
</style>

<Auth>
    <Layout>
        {#if isReading}
            <Reading />
        {/if}
        <h1>
            Scan your <strong>ID</strong>, <strong>driving licences</strong>
            or <strong>passports</strong>.
        </h1>
        <div class="content">
            <div class="tabs">
                <div class="tab{uploadType === 'everything'? ' active': ''}" on:click={() => uploadType = 'everything'}>Everything</div>
                <div class="tab{uploadType === 'separately'? ' active': ''}" on:click={() => uploadType = 'separately'}>Separately</div>
            </div>
            {#if uploadType === 'everything'}
                <UploadEverything />
            {/if}
            {#if uploadType === 'separately'}
                <UploadSeparately />
            {/if}
        </div>
        <div class="info">Personal information is treated properly. The uploaded images are not stored and the extracted information is discarded immediately after reading.</div>
    </Layout>
</Auth>
